import React from "react";
import excalamation from "../../../assets/img/icons/table/excalamation.svg";
import Button from "../../Button";
import Overlay from "../../Overlay";

function TresorerieLockError({ onCancel, open = true }) {
  const handleCloseDialog = () => {
    onCancel();
  };

  return (
    <Overlay show={open} closable={true} onClick={handleCloseDialog}>
      <div className="delete-confirm-wrapper">
        <div className="delete-confirm-container">
          <div className="are-you-sure">
            <img src={excalamation} alt={"excalamation"} />
            <p>Verrouillage du mode trésorerie</p>
          </div>

          <h1 className="popup-desc-content">
            Il existe des écritures non-pointées sur la période que vous
            souhaitez verrouiller (le mois sélectionné et tous les mois
            précédents non encore verrouillés).
            <br />
            <br />
            Vous ne pouvez donc pas verrouiller cette période.
            <br />
            <br />
            Pour pouvoir verrouiller une période, toutes les écritures de la
            période doivent avoir un statut « pointé ».
            <br />
            <br />
            Vous devez donc déplacer les écritures non pointées de la période
            sur la période suivante, avant de pouvoir verrouiller.
          </h1>

          <div className="delete-button-containers">
            <Button
              text={"Compris"}
              onClick={handleCloseDialog}
              className={"action-button agree-action-button"}
            />
          </div>
        </div>
      </div>
    </Overlay>
  );
}

export default TresorerieLockError;
